import { isNone } from '@ember/utils';
import Component from '@glimmer/component';

const COLOR_CLASS = {
  false: 'u-color-danger',
  true: 'u-color-success'
};
interface IArgs {
  tagName?: string;
  statType?: string;
  from?: number;
  to?: number;
  direction?: 'ASC' | 'DESC';
}

export default class TableStatDiff extends Component<IArgs> {
  get statType(): string {
    return this.args.statType ?? 'decimal';
  }

  // Computed Properties
  // ~~~~~
  get hasFrom() {
    const { from } = this.args;
    if (isNone(from)) {
      return false;
    }
    return !Number.isNaN(from);
  }

  get hasTo() {
    const { to } = this.args;
    if (isNone(to)) {
      return false;
    }
    return !Number.isNaN(to);
  }

  get improved() {
    const { from, to, direction } = this.args;
    const nFrom = from ?? 0;
    const nTo = to ?? 0;

    if (isNone(direction) || Number((nFrom - nTo).toFixed(5)) === 0) {
      return null;
    } else if (direction === 'ASC') {
      return nTo > nFrom;
    } else if (direction === 'DESC') {
      return nTo < nFrom;
    }
    return null;
  }

  get classFrom() {
    const { improved } = this;
    if (isNone(improved)) {
      return '';
    }
    return COLOR_CLASS[`${!improved}`];
  }

  get classTo() {
    const { improved } = this;

    if (isNone(improved)) {
      return '';
    }
    return COLOR_CLASS[`${improved}`];
  }
}
